import { render, staticRenderFns } from "./FileUpdate.vue?vue&type=template&id=1c824fec&scoped=true&"
import script from "./FileUpdate.vue?vue&type=script&lang=js&"
export * from "./FileUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c824fec",
  null
  
)

export default component.exports